import { X } from 'react-feather';

export default X;
